import { render, staticRenderFns } from "./modalNew.vue?vue&type=template&id=300ff499"
import script from "./modalNew.vue?vue&type=script&lang=js"
export * from "./modalNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports